<template>
  <div class="container pb-4">
    <h6 class="font-weight-bold">{{ TEXTS.render(`COMMENT_TITLE`) }}</h6>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label v-html="subHeading"></label>
          <textarea
            maxlength="150"
            class="form-control"
            name=""
            id=""
            rows="4"
            v-model="commentArea"
          ></textarea>
        </div>
        <p v-html="reminderText"></p>
      </div>
    </div>
  </div>
</template>

<script>
import Texts from "../../../../common/utils/Texts";
import helper from "../../../../helper";

export default {
  data() {
    return {
      commentArea: "",
      commentMap : {},
    };
  },
  mounted() {
    // Dispatch for Service Wording
    this.$store.dispatch("getServiceWording");
  },
  computed: {
    TEXTS: () => Texts,
    bookingState() {
      return this.$store.getters.GET_BOOKING_STATE;
    },
    selectedServiceId() {
      return this.bookingState && this.bookingState.selectedService
        ? this.bookingState.selectedService.service_setting_id
        : null;
    },
    selectedServiceWording() {
      return this.bookingState && this.bookingState.selectedService
        ? this.bookingState.selectedService.wording
        : null;
    },
    selectedServiceGroupName() {
      return this.bookingState && this.bookingState.selectedServiceGroup
        ? this.bookingState.selectedServiceGroup.group_name
        : "Hard waste";
    },
    subHeading() {
      return this.selectedServiceWording &&
        this.selectedServiceWording.comment_subheading
        ? this.selectedServiceWording.comment_subheading
        : Texts.render("COMMENT_SUBHEADER");
    },
    reminderText() {
      return this.selectedServiceWording &&
        this.selectedServiceWording.service_wordings_reminder
        ? this.selectedServiceWording.service_wordings_reminder
        : Texts.render("COMMENT_NOTE", null, {
            selectedServiceGroupName: this.selectedServiceGroupName,
          });
    },
  },
  watch: {
    commentArea(val){
      /*
        Stry: Adjustment_023 - Allow different comments per service
        Date: 2021-03-01
        Auth: Franco Mapua
      */  
      // --- Keeping this for legacy
      this.$store.dispatch("setBookingState", { comment: this.commentArea });

      // --- Send update to comment Map
      if(this.selectedServiceId){
        this.commentMap[this.selectedServiceId] = val
        this.$store.dispatch("setBookingState", { commentMap: this.commentMap });
      }
    },
    selectedServiceId(val){
      if(!this.commentMap[val]){
        this.commentMap[val] = ""
      }
      this.commentArea = this.commentMap[val]
    }
  },
  methods: {
    resetForm() {
      this.commentArea = "";
      this.commentMap = {};
      this.$store.dispatch("setBookingState", { commentMap: this.commentMap });
    },
  },
};
</script>